import { render, staticRenderFns } from "./data-sharing.vue?vue&type=template&id=1084bed3&"
import script from "./data-sharing.vue?vue&type=script&lang=js&"
export * from "./data-sharing.vue?vue&type=script&lang=js&"
import style0 from "./data-sharing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports